<template>
  <v-container fluid>
    <v-card>
      <v-card-title>Public Reference Materials</v-card-title>
      <v-divider />

      <v-card-text class="mx-auto">
        <v-data-table
          :headers="PublicReferenceMaterialsHeaders"
          :items="PublicReferenceMaterials"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: "accreditedInstitute",
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Dashboard/getaccreditedInstitute");
    });
  },
  computed: {
    PublicReferenceMaterialsHeaders() {
      return [
        {
          text: "code",
          align: "center",
          sortable: false,
          width: "500px",
          value: "code",
        },
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
      ];
    },
    PublicReferenceMaterials() {
      return [];
    },
  },
};
</script>
